import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { formatDateWithTime } from 'app/shared/util/date-utils';
import React, { useEffect, useMemo } from 'react';
import { FieldError, useForm } from 'react-hook-form';
import { ValidatedField, translate } from 'react-jhipster';
import { useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { getEntity } from '../device.reducer';

export const DeviceStatus = () => {
  const dispatch = useAppDispatch();
  const { id } = useParams<'id'>();

  const deviceEntity = useAppSelector(state => state.device.entity);
  const loading = useAppSelector(state => state.device.loading);

  const getLatestEntity = () => {
    dispatch(getEntity(id));
  };

  useEffect(() => {
    getLatestEntity();
  }, []);

  const {
    register,
    formState: { errors },
    reset: resetForm,
  } = useForm();

  const isSubscribed = !!deviceEntity?.billStatus;

  const defaultValues = useMemo(() => {
    return {
      serialNumber: deviceEntity?.serialNumber,
      state: deviceEntity?.state,
      provisionableAt: formatDateWithTime(deviceEntity?.provisionableAt),
      provisionedAt: formatDateWithTime(deviceEntity?.provisionedAt),
      registeredAt: formatDateWithTime(deviceEntity?.registeredAt),
      subscribedAt: formatDateWithTime(deviceEntity?.subscribedAt),
      unsubscribedAt: formatDateWithTime(deviceEntity?.unsubscribedAt),
    };
  }, [deviceEntity]);

  useEffect(() => {
    resetForm({
      ...defaultValues,
    });
  }, [defaultValues, resetForm]);

  return (
    <div className="status-tab">
      <div className="d-flex justify-content-end">
        <Button
          color="info"
          className="me-2"
          id="refresh-status"
          data-cy="refreshStatusButton"
          onClick={getLatestEntity}
          style={{ pointerEvents: loading ? 'none' : 'all' }}
        >
          <FontAwesomeIcon icon="sync" spin={loading} /> Refresh
        </Button>
      </div>
      <Row className="justify-content-start">
        <Col md="12">
          <form>
            <div className="form-body">
              <div className="d-flex">
                <ValidatedField
                  register={register}
                  type="text"
                  id="status-serial-no"
                  data-cy="status-serial-no"
                  name="serialNumber"
                  error={errors?.serialNumber as FieldError}
                  label={translate('rainspotApp.device.serialNumber')}
                  disabled={true}
                />

                <ValidatedField
                  register={register}
                  type="text"
                  id="status-device-status"
                  data-cy="status-device-status"
                  name="state"
                  error={errors?.state as FieldError}
                  label="Device Status"
                  disabled={true}
                />
              </div>

              <div className="d-flex">
                <ValidatedField
                  register={register}
                  type="text"
                  id="status-provisionable-at"
                  data-cy="status-provisionable-at"
                  name="provisionableAt"
                  error={errors?.provisionableAt as FieldError}
                  label="Provisionable"
                  disabled={true}
                />

                <ValidatedField
                  register={register}
                  type="text"
                  id="status-provisioned-at"
                  data-cy="status-provisioned-at"
                  name="provisionedAt"
                  error={errors?.provisionedAt as FieldError}
                  label="Provisioned"
                  disabled={true}
                />

                <ValidatedField
                  register={register}
                  type="text"
                  id="status-registered-at"
                  data-cy="status-registered-at"
                  name="registeredAt"
                  error={errors?.registeredAt as FieldError}
                  label="Registered"
                  disabled={true}
                />

                {isSubscribed ? (
                  <ValidatedField
                    register={register}
                    type="text"
                    id="status-subscribed-at"
                    data-cy="status-subscribed-at"
                    name="subscribedAt"
                    error={errors?.subscribedAt as FieldError}
                    label="Subscribed"
                    disabled={true}
                  />
                ) : (
                  <ValidatedField
                    register={register}
                    type="text"
                    id="status-unsubscribed-at"
                    data-cy="status-unsubscribed-at"
                    name="unsubscribedAt"
                    error={errors?.unsubscribedAt as FieldError}
                    label="Unsubscribed"
                    disabled={true}
                  />
                )}
              </div>
            </div>
          </form>
        </Col>
      </Row>
    </div>
  );
};

export default DeviceStatus;
